import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export const candidatFicheUrl = (dossierId, candidatId) => `/dossiers/${dossierId}/candidat/${candidatId}`;

export const CandidatLink = ({ dossierId, candidatId, children, className = '', icon = false, testId }) => {
  if (!dossierId || !candidatId) return <span className={className}>{children}</span>;
  return (
    <Link
      to={candidatFicheUrl(dossierId, candidatId)}
      onClick={(e) => e.stopPropagation()}
      title="Ouvrir la fiche candidat"
      className={`inline-flex items-center gap-1 text-indigo-700 underline decoration-dotted decoration-indigo-300 underline-offset-2 hover:decoration-solid hover:text-indigo-900 transition-colors ${className}`}
      data-testid={testId || `candidat-link-${candidatId}`}
    >
      {children}
      {icon && <ExternalLink className="w-3 h-3 opacity-50" />}
    </Link>
  );
};
